import { render, staticRenderFns } from "./loginByLYZZ.vue?vue&type=template&id=009a1f03"
import script from "./loginByLYZZ.vue?vue&type=script&lang=js"
export * from "./loginByLYZZ.vue?vue&type=script&lang=js"
import style0 from "./loginByLYZZ.vue?vue&type=style&index=0&id=009a1f03&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports